// Node entry point
//global.BUILD_ENV = require('./define.config.js');
module.exports = require('solclient-core');

